import { PriceType } from 'types/api/pricing.type';

const STORAGE_KEY = 'selectedPriceType';

const PRICE_TYPES: PriceType[] = ['DISTRIBUTOR', 'WHOLESALE', 'RETAIL'];

// The price type the user picked in a price selector. Kept in sessionStorage so
// the choice follows them across catalogue and order pages (and survives a
// reload) until the tab is closed or they log out.

function getPriceType(): PriceType | undefined {
  try {
    const value = window.sessionStorage.getItem(STORAGE_KEY);
    return PRICE_TYPES.find((type) => type === value);
  } catch {
    return undefined;
  }
}

function setPriceType(type: PriceType): void {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, type);
  } catch {
    // sessionStorage unavailable — the choice is simply not remembered
  }
}

function clearPriceType(): void {
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // sessionStorage unavailable — nothing to clear
  }
}

export const priceTypeStore = {
  getPriceType,
  setPriceType,
  clearPriceType,
};
